const BASE = '/api/v1';

export class ApiError extends Error {
  constructor(public status: number, public code: string, message: string, public details?: unknown) {
    super(message);
  }
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(BASE + path, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : {},
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  let json: unknown = null;
  try { json = text ? JSON.parse(text) : null; } catch { /* */ }
  if (!res.ok) {
    const err = (json ?? {}) as { error?: string; message?: string };
    throw new ApiError(res.status, err.error ?? 'UNKNOWN', err.message ?? `HTTP ${res.status}`);
  }
  return json as T;
}

export const api = {
  get: <T = unknown>(path: string) => request<T>('GET', path),
  post: <T = unknown>(path: string, body?: unknown) => request<T>('POST', path, body),
  put: <T = unknown>(path: string, body?: unknown) => request<T>('PUT', path, body),
  patch: <T = unknown>(path: string, body?: unknown) => request<T>('PATCH', path, body),
  delete: <T = unknown>(path: string) => request<T>('DELETE', path),
};

// === Typen ===

export type Me = {
  user: {
    id: string;
    email: string;
    roleName: string;
    permissions: string[];
    totpEnabled: boolean;
    mustChangePassword: boolean;
  } | null;
  mfaVerified: boolean;
};

export interface Role {
  id: string;
  name: string;
  description: string | null;
  permissions: string[];
  isBuiltIn: boolean;
  createdAt: string;
  _count?: { users: number };
}

export interface DashboardUser {
  id: string;
  email: string;
  status: 'active' | 'locked' | 'disabled';
  totpEnabled: boolean;
  createdAt: string;
  lastLoginAt: string | null;
  role: { id: string; name: string };
}

export interface PermissionDef {
  key: string;
  label: string;
  group: string;
}

/** Prüft ob der User eine bestimmte Permission hat */
export function hasPermission(permissions: string[] | undefined, required: string): boolean {
  if (!permissions) return false;
  if (permissions.includes('*')) return true;
  return permissions.includes(required);
}

/** Prüft ob der User Super-Admin ist */
export function isSuperAdmin(permissions: string[] | undefined): boolean {
  return permissions?.includes('*') ?? false;
}
